<!-- version 2021/05/20 -->
<template>
    <span>{{ text }}</span>
</template>

<script>
    export default {
        props: {
            text: String
        }
    }
</script>

<style lang="sass" scoped>
    span
        font-weight: 600
        font-size: 16px
        color: #002832
</style>